<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-04-13 16:04:19
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-08-02 10:06:26
-->
<template>
  <div class="widget-config">
    <el-form
      label-suffix="："
      v-if="this.data && Object.keys(this.data).length > 0"
      labelPosition="left"
      labelWidth="120px"
      size="small"
    >
      <component
        :is="`config-${data.type}`"
        :data="data"
        :collapse="collapse"
      ></component>
    </el-form>
  </div>
</template>
<script>
import fields from '@/dragComponents/model/index.js'

export default {
  name: 'widget-config',
  props: ['data'],
  data() {
    return {
      fields,
      collapse: '1'
    }
  }
}
</script>
